<template>
  <v-container>
    <modal
      name="show-comment"
      class="envivo-modal"
      @before-open="beforeOpen"
      @before-close="beforeClose"
      transition="pop-out"
      height="auto"
      adaptive
      :maxWidth="600"
      width="90%"
      scrollable
    >
      <div class="modal-wrapper">
        <div class="modal-title">
          {{ $t("clientSyncs.modal.commentTitle") }}
        </div>
        <div class="relative">
          <div class="modal-content">
            {{ modalContent }}
          </div>
          <div class="modal-buttons">
            <a class="v1 simple" @click="$modal.hide('show-comment')">{{ $t("actions.close") }}</a>
          </div>
        </div>
      </div>
    </modal>
    <v-row>
      <v-col stretch>
        <v-title-bar :title="$t('clientSyncs.title')"> </v-title-bar>
      </v-col>
    </v-row>
    <v-row v-if="clientSyncs && teamsSettings[$route.params.team]">
      <v-col class="col-12">
        <v-list-header complex>
          <v-list-header-cell size="2" :title="$t('clientSyncs.list.started')" />
          <v-list-header-cell
            :showAs="$t(teamsSettings[$route.params.team].listsSettings.clientSyncs.showAs.firstCol.label)"
            :size="teamsSettings[$route.params.team].listsSettings.clientSyncs.showAs.firstCol.size"
            :showAsDropdownUid="$h.createUniqueUid()"
            :showAsDropdown="showAsFirstColDropdown"
          />
          <v-list-header-cell size="1" :title="$t('clientSyncs.list.status')" />
          <v-list-header-cell size="1" :title="$t('clientSyncs.list.count')" />
          <v-list-header-cell emptyIcon />
        </v-list-header>
        <ul class="list">
          <v-list-item complex hover v-for="clientSync in clientSyncs" :key="clientSync.uid">
            <v-list-cell
              :title="$h.formatDate(clientSync.started_at, teams[$route.params.team].account.timezone)"
              size="2"
            />
            <v-list-cell
              :size="teamsSettings[$route.params.team].listsSettings.clientSyncs.showAs.firstCol.size"
              :value="
                $h.formatValue(
                  teamsSettings[$route.params.team].listsSettings.clientSyncs.showAs.firstCol.format,
                  clientSync[teamsSettings[$route.params.team].listsSettings.clientSyncs.showAs.firstCol.key],
                  teams[$route.params.team].account.timezone
                )
              "
            />
            <v-list-cell :value="clientSync.status" size="1" />
            <v-list-cell :value="clientSync.client_count" size="1" />
            <v-list-cell
              v-if="clientSync.comment"
              iconLink
              icon="Icon=info.svg"
              :onClick="
                () => {
                  $modal.show('show-comment', { comment: clientSync.comment });
                }
              "
            />
            <v-list-cell v-if="!clientSync.comment" emptyIcon />
          </v-list-item>
          <v-list-item v-if="!clientSyncs.length">
            <v-list-cell :value="$t('clientSyncs.list.noClientSyncs')"></v-list-cell>
          </v-list-item>
        </ul>
        <v-list-pagination
          :currentPage="teamsSettings[$route.params.team].listsSettings.clientSyncs.pagination.page"
          :showPerPage="teamsSettings[$route.params.team].listsSettings.clientSyncs.pagination.perPage"
          :totalPages="teamsSettings[$route.params.team].listsSettings.clientSyncs.pagination.lastPage"
          :apiCall="
            (page, perPage) => {
              changeClientSyncsPage(page, perPage);
            }
          "
        >
        </v-list-pagination>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import listSettings from "@/mixins/listSettings.js";
import clientSyncs from "@/mixins/dropdowns/clientSyncs.js";

export default {
  name: "ClientSyncsList",
  mixins: [listSettings, clientSyncs],
  data() {
    return {
      modalContent: "",
    };
  },
  created() {
    !this.teams[this.$route.params.team].account.team.attributes.client_sync
      ? this.$goTo("Dashboard")
      : this.loadPageData();
  },
  methods: {
    ...mapActions(["getClientSyncsList", "setListsSettings"]),
    beforeOpen(event) {
      this.$h.toggleHtmlScroll();
      this.modalContent = event.params.comment;
    },
    beforeClose() {
      this.$h.toggleHtmlScroll();
      this.modalContent = "";
    },
    loadPageData() {
      console.log("LOAD PAGE DATA");
      const vm = this;
      let params = {
        page: vm.teamsSettings[vm.$route.params.team].listsSettings.clientSyncs.pagination.page,
        per_page: vm.teamsSettings[vm.$route.params.team].listsSettings.clientSyncs.pagination.perPage,
        order_col: vm.teamsSettings[vm.$route.params.team].listsSettings.clientSyncs.order.col,
        order_dir: vm.teamsSettings[vm.$route.params.team].listsSettings.clientSyncs.order.dir,
      };
      vm.getClientSyncsList({
        setListsSettings: true,
        params,
      })
        .then((res) => {
          vm.initShowAs("clientSyncs");
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    changeClientSyncsPage(page, perPage) {
      let params = {
        page,
        per_page: perPage,
        order_col: this.teamsSettings[this.$route.params.team].listsSettings.clientSyncs.order.col,
        order_dir: this.teamsSettings[this.$route.params.team].listsSettings.clientSyncs.order.dir,
      };
      this.getClientSyncsList({
        setListsSettings: true,
        params,
      })
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  computed: {
    ...mapGetters({
      clientSyncs: "clients_get_client_syncs_list",
      teams: "auth_get_teams",
      teamsSettings: "global_get_teams_settings",
    }),
  },
};
</script>
